"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFormField = exports.DataFormChroot = exports.DataForm = void 0;
const DataFormContext_1 = require("./DataFormContext");
const DataFormField_1 = require("./DataFormField");
Object.defineProperty(exports, "DataFormField", { enumerable: true, get: function () { return DataFormField_1.DataFormField; } });
const DataFormChroot_1 = require("./DataFormChroot");
Object.defineProperty(exports, "DataFormChroot", { enumerable: true, get: function () { return DataFormChroot_1.DataFormChroot; } });
const definitions_1 = require("./definitions");
const chroot_1 = require("../ui-core/chroot");
const fcWrapper = 'dataForm:fcWrapper';
/** 用于自己组装表单的容器，支持 v-model 绑定 */
const DataForm = ({
    name: 'data-form',
    props: {
        value: { required: true },
        readonly: { type: Boolean, required: false },
        schema: Object,
        contextOptions: { required: false } // see DataFormContextOptions
    },
    model: {
        event: "change",
        prop: "value"
    },
    data() {
        return {
            editValue: null,
            [fcWrapper]: null,
        };
    },
    computed: {
        formContext: {
            get() { return this[fcWrapper].formContext; },
            set(formContext) { this[fcWrapper] = Object.seal({ formContext }); }
        },
        rootStub() {
            return this.formContext.rootStub;
        },
        chrootContext() {
            return new chroot_1.ChrootContext({ stub: this.rootStub });
        }
    },
    created() {
        let supressOnce = false;
        this.editValue = this.value;
        this.$watch('schema', (schema) => {
            const formContext = new DataFormContext_1.DataFormContext(schema, Object.assign(Object.assign({}, (this.contextOptions || {})), { initialValue: this.editValue }));
            this.formContext = formContext;
        }, { immediate: true, deep: true });
        const onStubChange = (stub, oldValue, trace) => {
            if (supressOnce) {
                supressOnce = false;
                return;
            }
            this.editValue = stub.value;
            this.$emit('change', this.editValue, oldValue, trace);
            this.$emit('update:value', this.editValue);
        };
        this.$watch('readonly', (val) => {
            this.rootStub.readonly = !!val;
        }, { immediate: true });
        this.$watch('value', (val) => {
            if (val !== this.editValue) {
                supressOnce = true;
                this.editValue = val;
                this.rootStub.setValue(this.editValue);
            }
        }, { deep: false });
        this.$watch('rootStub', (rootStub, oldRootStub) => {
            oldRootStub === null || oldRootStub === void 0 ? void 0 : oldRootStub.off("change", onStubChange);
            rootStub === null || rootStub === void 0 ? void 0 : rootStub.on("change", onStubChange);
        }, { immediate: true, deep: false });
    },
    provide() {
        return {
            [definitions_1.$formContext]: () => this.formContext,
            [definitions_1.$chrootContext]: () => this.chrootContext,
            [definitions_1.$injectDataField]: null, // reset 
        };
    },
    render(h) {
        const children = this.$slots.default || [
            h(DataFormField_1.DataFormField, { props: { path: "" } })
        ];
        return h('div', { staticClass: 'ds-dataform' }, children);
    }
});
exports.DataForm = DataForm;
exports.default = DataForm;
//# sourceMappingURL=DataForm.js.map